import React from 'react';

import "./numberBichoGroup.css";
import NumberBicho from './numberBicho';

/**
 * @type {( props: {
*  numbers: number[] | string;
*  cart: {
*   number: number;
*   amount: number;
*   value: number;
*   }[]
*  isCombined?: boolean;
*  separatorChar?: boolean;
*  separatorElement?: React.ReactNode;
*  hideCorrespondantNumbers?: boolean;
*  hideAnimals?: boolean;
*  withCloseButton?: boolean;
*  closeElement?: React.ReactNode;
*  onCloseClick?: (num: string | number) => void;
* }) => React.ReactNode }
*/

function NumberBichoGroup(props) {
  const separatorElement = <span className="separator">{props.separatorElement || "x"}</span>;
  const cart = props.cart || [];

  return props.isCombined || props.numbers[0] &&  props.separatorChar && props.separatorChar.length && props.numbers[0].includes(props.separatorChar)
    ? props.numbers.map((combinationString) => {
      const combinations = combinationString.split(props.separatorChar);

      return (
      <div className="combined-bicho-group">
        { props.withCloseButton && <span className='bicho-group-remove-button' onClick={() => props.onCloseClick(combinationString)}>{props.closeElement || "x"}</span> }
        { combinations.map((number, numberIndex) => (
          <React.Fragment>
            <NumberBicho number={number} onClick={() => {}} readonly hideCorrespondantNumbers={props.hideCorrespondantNumbers} showAnimal={!props.hideAnimals}/>
            { numberIndex < combinations.length - 1 &&  separatorElement }
          </React.Fragment>
        ))}
      </div>
      )})
    : <div className="normal-bicho-group">
        { props.numbers.map((number, cartIndex) => (
          <div className="bicho-group-number-wrapper">
            <NumberBicho number={number} betAmount={(cart[cartIndex] || {}).amount} onClick={() => {}} readonly hideCorrespondantNumbers={props.hideCorrespondantNumbers} showAnimal={!props.hideAnimals}/>
            { props.withCloseButton && <span className='bicho-group-remove-button' onClick={() => props.onCloseClick(number)}>{props.closeElement || "x"}</span> }
          </div>
          ) )}
    </div>
}

export { NumberBichoGroup };


// WEBPACK FOOTER //
// ./src/rifa/components/layout/numberBichoGroup.jsx